import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
export const getCrmObjectIdAndCallerIdFromCallId = callId => {
  const portalId = PortalIdParser.get() || '';
  const url = `calls/v1/call/live-crm-context/${callId}`;
  return http.get(url, {
    timeout: 1000,
    query: {
      portalId
    }
  });
};